import React from "react";
import { Badge } from "react-bootstrap";

export default key => <Badge className="alert-danger">disabled</Badge>;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/DisableBadge.js